<!-- eslint-disable @angular-eslint/template/role-has-required-aria -->

<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<!-- Container -->
<div
  class="relative w-full group"
  role="combobox"
  aria-haspopup="listbox"
  [attr.aria-expanded]="open()"
  [attr.aria-disabled]="disabled()">
  @if (label()) {
    <label [class]="labelClasses" [attr.aria-hidden]="true">
      {{ label() }}
    </label>
  }
  <!-- Button -->
  <button
    [class]="comboboxButtonClasses"
    aria-label="Select an option"
    [attr.aria-controls]="'combobox-options'"
    type="button"
    (click)="toggleCombobox()">
    <div class="flex flex-row items-center justify-between">
      @if (selectedOption()) {
        {{ selectedOption()?.value }}
      } @else {
        <span class="text-foreground-50 font-light">{{ placeholder() }}</span>
      }
      <span
        appIcon
        name="chevron-down"
        [size]="iconSize"
        class="inline-block align-middle"
        aria-hidden="true"></span>
    </div>
  </button>
  @if (open() && !disabled()) {
    <!-- Menu -->
    <div [class]="'absolute z-50 mt-2 w-full ' + comboboxMenuClasses">
      <!-- Input -->
      <div class="relative">
        <input
          #searchInput
          [class]="comboboxInputClasses"
          [value]="search()"
          (input)="search.set(searchInput.value)"
          (keydown)="handleKeyDown($event)"
          role="searchbox"
          aria-label="Search options"
          aria-autocomplete="list"
          aria-controls="combobox-options"
          type="text" />
        <span
          appIcon
          name="search"
          [size]="18"
          class="absolute bg-white right-3 top-1/2 -translate-y-1/2 text-foreground-50"
          aria-hidden="true"></span>
      </div>
      <!-- Options -->
      <ul
        class="max-h-60 overflow-y-auto"
        role="listbox"
        id="combobox-options"
        aria-label="Lista de opciones">
        @for (option of filteredOptions(); track option.id; let i = $index) {
          <li
            [id]="'option-' + option.id"
            [class]="
              comboboxOptionClasses +
              (selectedOption() === option ? ' bg-foreground-5' : '') +
              (focusedOptionIndex() === i ? ' bg-foreground-10' : '')
            "
            tabindex="0"
            (keydown)="handleKeyDown($event)"
            (focus)="handleOptionFocus(option)"
            (mouseenter)="handleOptionFocus(option)"
            role="option"
            [attr.aria-selected]="selectedOption() === option"
            (click)="selectOption(option)">
            <div class="flex flex-row items-center gap-4">
              {{ option.value }}
              @if (selectedOption() === option) {
                <span
                  appIcon
                  name="check"
                  [size]="18"
                  aria-hidden="true"></span>
              }
            </div>
          </li>
        }

        @if (filteredOptions().length === 0) {
          <li
            [class]="comboboxOptionClasses"
            role="option"
            (keydown)="handleKeyDown($event)"
            tabindex="0"
            aria-disabled="true">
            No results
          </li>
        }
      </ul>
    </div>
  }
</div>
